export default __webpack_public_path__ + "static/media/fpx.0123d5a4.svg";